/**
 * Utilities for converting SMPTE timecode to seconds and miliseconds.
 * Lifted and modified from Allen Sarkisyan's VideoFrame library:
 *     https://github.com/X3TechnologyGroup/VideoFrame
 */

var SMPTEUtils = function (options) {
  this.frameRate = options.frameRate || 24;
};

/**
 * Converts a SMPTE Time code to Seconds
 *
 * @param  {String} SMPTE - a SMPTE time code in HH:MM:SS:FF format
 * @return {Number} Returns the Second count of a SMPTE Time code
 */
SMPTEUtils.prototype.toSeconds = function(SMPTE) {
  if (!SMPTE) {
    return;
  }
  var time = SMPTE.split(':');
  return (((Number(time[0]) * 60) * 60) + (Number(time[1]) * 60) + Number(time[2]));
};

/**
 * Converts a SMPTE Time code, or standard time code to Milliseconds
 *
 * @param  {String} SMPTE OPTIONAL: a SMPTE time code in HH:MM:SS:FF format,
 * or standard time code in HH:MM:SS format.
 * @return {Number} Returns the Millisecond count of a SMPTE Time code
 */
SMPTEUtils.prototype.toMilliseconds = function(SMPTE) {
  if (!SMPTE) {
    return;
  }
  var frames = Number(SMPTE.split(':')[3]);
  var milliseconds = (1000 / this.frameRate) * (isNaN(frames) ? 0 : frames);
  return Math.floor(((this.toSeconds(SMPTE) * 1000) + milliseconds));
};

/**
 * Converts a SMPTE Time code to HTML5 Video Timecode
 *
 * @param  {String} SMPTE - a SMPTE time code in HH:MM:SS:FF format
 * @return {Number} Returns the Second + Millisecond count of a SMPTE Time code
 */
SMPTEUtils.prototype.toTimeCode = function(SMPTE) {
  if (!SMPTE || typeof SMPTE !== "string") {
    return;
  }
  return ((this.toMilliseconds(SMPTE) / 1000) + 0.001);
};

module.exports = SMPTEUtils;
